import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { initAuth, scheduleRefresh } from './auth';
import './LoginPage.css';

const LoginPage = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();

  React.useEffect(() => {
    const token = searchParams.get('token');
    const refreshToken = searchParams.get('refresh_token');
    if (token) {
      localStorage.setItem('nf_token', token);
      if (refreshToken) localStorage.setItem('nf_refresh', refreshToken);
      initAuth();
      scheduleRefresh();
      if (onLoginSuccess) onLoginSuccess();
    }
  }, [searchParams, onLoginSuccess]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await fetch('/auth0/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`
      });
      if (!response.ok) { setError('Invalid email or password'); setLoading(false); return; }
      const raw = await response.text();
      var data;
      try { data = JSON.parse(raw); } catch (parseErr) { setError('Login failed — unexpected response'); setLoading(false); return; }
      if (data.token) {
        localStorage.setItem('nf_token', data.token);
        if (data.refresh_token) localStorage.setItem('nf_refresh_token', data.refresh_token);
        initAuth();
        scheduleRefresh();
        if (onLoginSuccess) onLoginSuccess();
      } else { setError('Login failed — no token received'); }
    } catch (err) { setError('Connection error — please try again'); }
    setLoading(false);
  };

  const handleGoogleLogin = () => { window.location.href = '/auth/google'; };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <img src="/assets/dynamic/NumFreeSymbol.png" className="login-logo" alt="" />
          <h2>Welcome back</h2>
          <p className="login-tagline">Sign in to your numbers, calls, and assistant.</p>
        </div>

        {error && <div className="login-error">{error}</div>}

        <form className="login-form" onSubmit={handleSubmit} data-testid="login-form">
          <div className="login-field">
            <input data-testid="login-email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" required autoFocus />
          </div>
          <div className="login-field">
            <input data-testid="login-password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" required />
          </div>
          <button className="login-btn" data-testid="login-submit" type="submit" disabled={loading}>
            {loading && <span className="login-spinner" />}
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="login-divider"><span>or</span></div>

        <button className="login-google-btn" onClick={handleGoogleLogin}>
          <svg width="18" height="18" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
          Continue with Google
        </button>

        <div className="login-alt-hint">New to NumFree?</div>
        <Link className="login-alt-btn" to="/signup" data-testid="login-go-signup">
          Create an account
        </Link>
      </div>
    </div>
  );
};

export default LoginPage;
